import { render } from "./SimpleBox.vue?vue&type=template&id=686d1e8c&scoped=true"
import script from "./SimpleBox.vue?vue&type=script&lang=js"
export * from "./SimpleBox.vue?vue&type=script&lang=js"

import "./SimpleBox.vue?vue&type=style&index=0&id=686d1e8c&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686d1e8c"]])

export default __exports__